import PropTypes from "prop-types";
import React, { Component } from "react";
import DataTable from "./datatable/DataTable";
import moment from "moment";
import { objectById } from "@mc/mc-legacy";
const { ColumnType, ColumnAlignment } = DataTable;
export default class ZadostTable extends Component {
  static propTypes = {
    rows: PropTypes.array.isRequired,
    personList: PropTypes.array.isRequired,
  };

  constructor(props) {
    super(props);
    const personList = props.personList;

    const getPerson = (id, list) => {
      let person = objectById(list, id);
      return person ? person.loginName : "";
    };

    this.columns = [
      {
        component: (item) => (item.row.counts ? <span>{item.row.counts.idRequest}</span> : null),
        label: "ID Požadavku",
      },
      {
        name: "sourceOrganization",
        label: "Organizace",
      },
      {
        component: (item) => <span>{getPerson(item.row.idPrRequest, personList)}</span>,
        label: "Předkladatel",
      },
      {
        component: (item) => <span>{moment(item.row.counts.executionChange).format("D.M.YYYY")}</span>,
        label: "Datum vyřizování",
      },
      {
        component: (item) => <span>{getPerson(item.row.idPrSign, personList)}</span>,
        label: "Podepisující",
      },
      {
        component: (item) => <span>{item.row.counts.useTimestamp}</span>,
        label: "Počet časových razítek podpisu",
      },
      {
        component: (item) => <span>{item.row.counts.useSealTimestamp}</span>,
        label: "Počet časových razítek pečeti",
      },
      {
        component: (item) => <span>{item.row.counts.totalDocuments}</span>,
        label: "Celkový počet dokumentů",
      },
      {
        component: (item) => <span>{item.row.counts.signedDocuments}</span>,
        label: "Počet podepsaných dokumentů",
      },
      {
        component: (item) => <span>{item.row.counts.rejectedDocuments}</span>,
        label: "Počet odmítnutých dokumentů",
      },
      {
        component: (item) => <span>{item.row.counts.viewedDocuments}</span>,
        label: "Počet zobrazených dokumentů",
      },
    ];
  }

  render() {
    const { rows } = this.props;
    return (
      <DataTable
        rmClass={true}
        columns={this.columns}
        rows={rows}
        bodyProps={{
          className: "items-list",
        }}
        bodyRowProps={{
          className: "card-body actions-hover",
        }}
        striped
        hover
        bordered
      />
    );
  }
}
